import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

// pkg/dist-src/types.js
var Algorithm = /* @__PURE__ */function (Algorithm2) {
  Algorithm2["SHA1"] = "sha1";
  Algorithm2["SHA256"] = "sha256";
  return Algorithm2;
}(Algorithm || {}); // pkg/dist-src/utils.js


var getAlgorithm = function getAlgorithm(signature) {
  return signature.startsWith("sha256=") ? "sha256" : "sha1";
}; // pkg/dist-src/web.js


var enc = new TextEncoder();

function hexToUInt8Array(string) {
  var pairs = string.match(/[\dA-F]{2}/gi);
  var integers = pairs.map(function (s) {
    return parseInt(s, 16);
  });
  return new Uint8Array(integers);
}

function UInt8ArrayToHex(signature) {
  return Array.prototype.map.call(new Uint8Array(signature), function (x) {
    return x.toString(16).padStart(2, "0");
  }).join("");
}

function getHMACHashName(algorithm) {
  var _Algorithm$SHA1$Algor;

  return (_Algorithm$SHA1$Algor = {}, _defineProperty(_Algorithm$SHA1$Algor, Algorithm.SHA1, "SHA-1"), _defineProperty(_Algorithm$SHA1$Algor, Algorithm.SHA256, "SHA-256"), _Algorithm$SHA1$Algor)[algorithm];
}

function importKey(_x, _x2) {
  return _importKey.apply(this, arguments);
}

function _importKey() {
  _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(secret, algorithm) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", crypto.subtle.importKey("raw", // raw format of the key - should be Uint8Array
            enc.encode(secret), {
              // algorithm details
              name: "HMAC",
              hash: {
                name: getHMACHashName(algorithm)
              }
            }, false, // export = false
            ["sign", "verify"] // what this key can do
            ));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _importKey.apply(this, arguments);
}

function sign(_x3, _x4) {
  return _sign.apply(this, arguments);
}

function _sign() {
  _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options, payload) {
    var _ref, secret, algorithm, signature;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref = typeof options === "object" ? {
              secret: options.secret,
              algorithm: options.algorithm || Algorithm.SHA256
            } : {
              secret: options,
              algorithm: Algorithm.SHA256
            }, secret = _ref.secret, algorithm = _ref.algorithm;

            if (!(!secret || !payload)) {
              _context2.next = 3;
              break;
            }

            throw new TypeError("[@octokit/webhooks-methods] secret & payload required for sign()");

          case 3:
            if (Object.values(Algorithm).includes(algorithm)) {
              _context2.next = 5;
              break;
            }

            throw new TypeError("[@octokit/webhooks] Algorithm ".concat(algorithm, " is not supported. Must be  'sha1' or 'sha256'"));

          case 5:
            _context2.t0 = crypto.subtle;
            _context2.next = 8;
            return importKey(secret, algorithm);

          case 8:
            _context2.t1 = _context2.sent;
            _context2.t2 = enc.encode(payload);
            _context2.next = 12;
            return _context2.t0.sign.call(_context2.t0, "HMAC", _context2.t1, _context2.t2);

          case 12:
            signature = _context2.sent;
            return _context2.abrupt("return", "".concat(algorithm, "=").concat(UInt8ArrayToHex(signature)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sign.apply(this, arguments);
}

function verify(_x5, _x6, _x7) {
  return _verify.apply(this, arguments);
}

function _verify() {
  _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(secret, eventPayload, signature) {
    var algorithm;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!secret || !eventPayload || !signature)) {
              _context3.next = 2;
              break;
            }

            throw new TypeError("[@octokit/webhooks-methods] secret, eventPayload & signature required");

          case 2:
            algorithm = getAlgorithm(signature);
            _context3.t0 = crypto.subtle;
            _context3.next = 6;
            return importKey(secret, algorithm);

          case 6:
            _context3.t1 = _context3.sent;
            _context3.t2 = hexToUInt8Array(signature.replace("".concat(algorithm, "="), ""));
            _context3.t3 = enc.encode(eventPayload);
            _context3.next = 11;
            return _context3.t0.verify.call(_context3.t0, "HMAC", _context3.t1, _context3.t2, _context3.t3);

          case 11:
            return _context3.abrupt("return", _context3.sent);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _verify.apply(this, arguments);
}

export { sign, verify };